module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-check-icon.0bc5956a.svg";